import Backdrop from '@material-ui/core/Backdrop';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      background: 'rgba(255, 255, 255, .5)',
      borderRadius: theme.shape.borderRadius,
      position: 'absolute',
      zIndex: theme.zIndex.appBar
    }
  });

export const Overlay = withStyles(styles)(Backdrop);
